module.exports = __webpack_public_path__ + "img/6to-informe.9ddd67ed.jpg";